import type { Theme } from '../../core/types';
import { PainBehavior } from './behavior';

/** Each drawing is registered at the feet, not at the centre of a billowing cloak. */
export const painTheme: Theme = {
  id: 'pain',
  name: 'Pain Tendô',
  primaryAction: 'shinratensei',
  primaryLabel: 'Pain : Shinra Tensei',
  pointerAction: 'rinnegan',
  greetings: [
    'Ce site connaîtra la douleur.',
    'Approche.',
    'Même ce bouton résiste…',
    'Un instant de silence.',
    'La gravité ne négocie pas.',
    'Je veille sur cette page.',
  ],
  autoplay: [
    'levitate',
    'levitate',
    'levitate',
    'levitate',
    'rinnegan',
    'rinnegan',
    'rinnegan',
    'rain',
    'rain',
    'prepare',
    'prepare',
    'shinratensei',
    'shinratensei',
    'banshotenin',
    'banshotenin',
    'receivers',
    'receivers',
    'chibakutensei',
  ],
  createBehavior: (context) => new PainBehavior(context),
  character: {
    unitHeight: 358,
    frames: Array.from(
      { length: 12 },
      (_, i) => [(i % 4) * 362, Math.floor(i / 4) * 362, 362, 362] as const,
    ),
    pivots: [
      { x: 199, y: 360 },
      { x: 198, y: 360 },
      { x: 180, y: 360 },
      { x: 181, y: 360 },
      { x: 190, y: 360 },
      { x: 175, y: 358 },
      { x: 180, y: 360 },
      { x: 174, y: 354 },
      { x: 186, y: 352 },
      { x: 189, y: 354 },
      { x: 183, y: 354 },
      { x: 188, y: 354 },
    ],
  },
  atlases: {
    gravity: {
      unitHeight: 662,
      frames: [
        [0, 0, 512, 768],
        [512, 0, 512, 768],
        [1024, 0, 512, 768],
        [1536, 0, 512, 768],
      ],
      pivots: [
        { x: 236, y: 722 },
        { x: 229, y: 718 },
        { x: 256, y: 720 },
        { x: 257, y: 720 },
      ],
    },
    levitation: {
      unitHeight: 586,
      frames: [
        [150, 0, 430, 606],
        [750, 0, 420, 606],
        [90, 606, 600, 600],
        [760, 606, 470, 600],
      ],
      pivots: [
        { x: 203, y: 601 },
        { x: 212, y: 601 },
        { x: 264, y: 584 },
        { x: 203, y: 584 },
      ],
    },
  },
  clips: {
    idle: { frames: [0, 0, 1, 0], fps: 1.4, loop: true },
    perch: { frames: [0, 0, 1, 0], fps: 1.4, loop: true },
    watch: { frames: [0], fps: 1, loop: true, lookFrames: { up: 3, down: 2, neutral: 0 } },
    prepare: { asset: 'gravity', frames: [0], fps: 1, loop: true },
    repel: { asset: 'gravity', frames: [1], fps: 1, loop: true },
    attract: { asset: 'gravity', frames: [2], fps: 1, loop: true },
    gravity: { asset: 'gravity', frames: [3], fps: 1, loop: true, speechClearance: 2.1 },
    float: { asset: 'levitation', frames: [0, 1, 2, 3, 2, 1], fps: 6, loop: true },
    receiver: { frames: [9], fps: 1, loop: true },
    rain: { frames: [11], fps: 1, loop: true },
  },
  messages: {
    shinratensei: 'Shinra Tensei.',
    banshotenin: 'Banshō Ten’in.',
    chibakutensei: 'Chibaku Tensei.',
    levitate: 'La hauteur change la perspective.',
    receivers: 'Ne bouge plus.',
    rinnegan: 'Je te vois.',
    rain: 'La pluie ne s’arrête jamais à Amegakure.',
    prepare: 'Un peu de chakra…',
  },
  assets: { character: 'character.webp', gravity: 'gravity.webp', levitation: 'levitation.webp' },
};
